import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDesignMode } from '../contexts/DesignContext';
import { classNames } from '../utils/classNames';
import ga from '../services/analytics';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { isSketchy } = useDesignMode();
  const currentYear = new Date().getFullYear();

  const handleCannyClick = () => {
    ga.event('outbound_link_click', {
      link_url: 'https://cassette.canny.io/features',
      link_text: 'Feature Requests'
    });
  };

  return (
    <footer
      data-testid="footer"
      className={classNames(
        'py-6 w-full',
        isSketchy
          ? 'border-t-2 border-dashed border-[var(--color-border)] bg-[color-mix(in_srgb,var(--color-bg)_92%,transparent)]'
          : 'bg-[var(--color-surface)] border-t border-[var(--color-border)]'
      )}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col space-y-4 sm:hidden px-4">
          <div className="text-sm text-[var(--color-muted)] text-center">
            {t('footer.copyright', { year: currentYear })}
          </div>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <a
              href="https://cassette.canny.io/features"
              className="text-[var(--color-primary)] hover:text-[var(--color-primary)]/80 font-medium transition-colors text-center"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCannyClick}
            >
              {t('footer.featureRequests')}
            </a>
            <Link
              to="/docs"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors text-center"
            >
              {t('footer.docs')}
            </Link>
            <a
              href="/policy.html"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors text-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.privacyPolicy')}
            </a>
            <a
              href="/terms.html"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors text-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.termsOfService')}
            </a>
            <a
              href="mailto:cassette.track.management@gmail.com"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors text-center"
            >
              {t('footer.contactUs')}
            </a>
          </div>
          <div className="text-sm text-[var(--color-muted)] text-center pt-2">
            {t('footer.madeWithLove')}
          </div>
        </div>

        <div className="hidden sm:flex sm:justify-between sm:items-center px-4 sm:px-0">
          <div className="text-sm text-[var(--color-muted)]">
            {t('footer.copyright', { year: currentYear })}
          </div>
          <div className="flex flex-row items-center gap-4 lg:gap-6 text-sm">
            <a
              href="https://cassette.canny.io/features"
              className="text-[var(--color-primary)] hover:text-[var(--color-primary)]/80 font-medium transition-colors"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCannyClick}
            >
              {t('footer.featureRequests')}
            </a>
            <Link
              to="/docs"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
            >
              {t('footer.docs')}
            </Link>
            <a
              href="/policy.html"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.privacyPolicy')}
            </a>
            <a
              href="/terms.html"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.termsOfService')}
            </a>
            <a
              href="mailto:cassette.track.management@gmail.com"
              className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
            >
              {t('footer.contactUs')}
            </a>
            <span className="text-[var(--color-muted)] ml-4">
              {t('footer.madeWithLove')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
